<script lang="ts">
  import { _ } from 'svelte-i18n';

  import AddToListMenu from '$lib/components/AddToListMenu.svelte';
  import { filteredMixedResults } from '$lib/stores/mixedResults';

  /**
   * The whole selection into a saved list.
   *
   * # It stands where "Auswahl speichern" stood
   *
   * That control was `ShareSelection`: a bookmark icon, the word "save", and a
   * menu offering a link to copy or mail. It mints a public share code — which
   * is a way to *hand a selection to somebody*, not a way to keep one. For a
   * signed-in customer the promise was wrong twice over: saved lists are what
   * keeping a selection means here, they are owned by the account and outlive
   * the session, and the bookmark is their icon.
   *
   * So in the members' build this takes that slot and `ShareSelection` stays
   * with the public one, where a link is the only kind of keeping there is.
   *
   * # The rows on screen, not everything held
   *
   * `filteredMixedResults` rather than the whole set: a customer who narrows by
   * score and then adds "all" means the ones they can see. The API's
   * thousand-record cap is not this component's problem — `addRecordsToList`
   * batches.
   *
   * Companies only. A row shows role counts and no names, because names live
   * behind the metered profile door, so there is no individual person here to
   * add.
   */

  const count = $derived($filteredMixedResults.length);
</script>

{#if count > 0}
  <AddToListMenu
    records={() => $filteredMixedResults.map((company) => ({ company_id: company.id }))}
    {count}
    withLabel
    variant="bar"
    label={$_('savedLists.add.allInSelection', { values: { count } })}
  />
{/if}
